import axios from "axios";

const url = process.env.REACT_APP_BACKEND_HOST.concat("/spot/");

export async function updateClassIdsEdit(token, selectedClass) {
	//update_classid_edit
	return new Promise((resolve, reject) => {
		axios({
			method: "POST",
			url: url + "update_classid_edit/",
			headers: {
				Authorization: `Token ${token}`,
			},
			data: selectedClass,
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function updateManyClassesClassAdjust({ token, classesToUpdate, ccid }) {
	return new Promise((resolve, reject) => {
		axios({
			method: "put",
			url: url + "update_many_class_adjust/",
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			data: { classesToUpdate, ccid },
		})
			.then((response) => {
				if (response.status === 200) resolve(response.data);
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function importSpreadsheet(token, data) {
	return new Promise((resolve, reject) => {
		axios({
			method: "post",
			url: url + "import_spreadsheet/",
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			data: data,
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function toggleWebUserSettings(token, ccid, setting) {
	return new Promise((resolve, reject) => {
		axios({
			method: "post",
			url: url + "toggle_web_user_settings/",
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			data: { ccid: ccid, setting: setting },
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function postRFSData(token, rfsData) {
	return new Promise((resolve, reject) => {
		axios({
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			method: "post",
			url: process.env.REACT_APP_BACKEND_HOST.concat("/scanner/new_scanner_requisition/"),
			data: rfsData,
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function postAssign2(token, data) {
	return new Promise((resolve, reject) => {
		axios({
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			method: "post",
			url: process.env.REACT_APP_BACKEND_HOST.concat("/scanner/new_assign2_requisition/"),
			data: data,
		})
			.then((response) => {
				if (response.status === 201) {
					resolve(response);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function postItem(token, item) {
	return new Promise((resolve, reject) => {
		axios({
			method: "post",
			url: url + "post_item/",
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			data: item,
		})
			.then((response) => {
				if (response.status === 201) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function postRoles({ token, role }) {
	return new Promise((resolve, reject) => {
		axios({
			method: "post",
			url: url + "post_roles/",
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			data: role,
		})
			.then((response) => {
				if (response.status === 201) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function postBulkBlueCourses({ token, classesToSubmit, ccid }) {
	return new Promise((resolve, reject) => {
		axios({
			method: "post",
			url: url + "submit_bulk_blue_courses/",
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			data: { classesToSubmit: classesToSubmit, ccid: ccid },
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function validateAndCreateUsers({ token, instructors }) {
	return new Promise((resolve, reject) => {
		axios({
			method: "post",
			url: url + "validate_and_create_users/",
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			data: { instructors },
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function postAllClassesClassAdjust({ token, classesToSubmit, ccid }) {
	return new Promise((resolve, reject) => {
		axios({
			method: "post",
			url: url + "submit_all_class_adjust/",
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			data: { classesToSubmit: classesToSubmit, ccid: ccid },
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function postClassIdsAndRoles({ token, listOfNewRows }) {
	return new Promise((resolve, reject) => {
		axios({
			method: "post",
			url: url + "post_instanced_classids_and_roles/",
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			data: listOfNewRows,
		})
			.then((response) => {
				if (response.status === 201) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function postFacultyRank(token, instructor) {
	return new Promise((resolve, reject) => {
		axios({
			method: "post",
			url: url + "post_faculty_rank/",
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			data: instructor,
		})
			.then((response) => {
				if (response.status === 201) {
					resolve(response);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function populateQPUsers(token, termValue) {
	return new Promise((resolve, reject) => {
		axios({
			method: "post",
			url: url + "populate_qp_users/",
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			data: {
				term: termValue,
			},
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	});
}

export async function postWebUser(token, webUser) {
	return new Promise((resolve, reject) => {
		axios({
			method: "post",
			url: url + "post_web_user/",
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			data: webUser,
		})
			.then((response) => {
				if (response.status === 201) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function postBlockId(token, blockid) {
	return new Promise((resolve, reject) => {
		axios({
			method: "post",
			url: url + "post_blockid/",
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			data: blockid,
		})
			.then((response) => {
				if (response.status === 201) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function postTempAccess(token, tempAccess) {
	return new Promise((resolve, reject) => {
		axios({
			method: "post",
			url: url + "post_temp_access/",
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			data: tempAccess,
		})
			.then((response) => {
				if (response.status === 201) {
					resolve(response);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function postBlockItems(token, blockItems) {
	return new Promise((resolve, reject) => {
		axios({
			method: "post",
			url: url + "post_blockitems/",
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			data: blockItems,
		})
			.then((response) => {
				if (response.status === 201) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}
